(function ($) {
	class W4D_FrontendHelper {
		constructor() {
			this.initSelectors();
			this.bindEvents();
			this.initCartRefresh();
			this.qualizePortfolio2Heights();
			this.setupFocusTracking();
		}

		setupFocusTracking() {
			$(window).on('keydown', (e) => {
				if (e.key === 'Tab') this.lastInteractionWasKeyboard = true;
			});

			$(window).on('mousedown', () => {
				this.lastInteractionWasKeyboard = false;
			});

			// Only add the attribute for keyboard focus
			$(document).on('focus', 'input, textarea', (e) => {
				const $input = $(e.currentTarget);
				if (this.lastInteractionWasKeyboard) {
					$input.attr('data-focus-source', 'keyboard');
				} else {
					$input.removeAttr('data-focus-source');
				}
			});

			$(document).on('blur', 'input, textarea', (e) => {
				$(e.currentTarget).removeAttr('data-focus-source');
			});
		}

		qualizePortfolio2Heights() {
			if ($(window).width() > 768) {
				$('.portfolio-2__text h3, .portfolio-2__text p').height('auto');
				const $cards = $('.portfolio-2__card');

				if ($cards.length) {
					let maxH3Height = 0;
					$cards.find('.portfolio-2__text h3').each(function () {
						maxH3Height = Math.max(maxH3Height, $(this).outerHeight());
					});
					$cards.find('.portfolio-2__text h3').height(maxH3Height);

					let maxPHeight = 0;
					$cards.find('.portfolio-2__text p').each(function () {
						maxPHeight = Math.max(maxPHeight, $(this).outerHeight());
					});
					$cards.find('.portfolio-2__text p').height(maxPHeight);
				}
			} else {
				// Reset heights on mobile
				$('.portfolio-2__text h3, .portfolio-2__text p').height('auto');
			}
		}

		initCartRefresh() {
			$(window).on('pageshow', (e) => {
				if (e.originalEvent.persisted) {
					this.updateCartFromStorage();
				}
			});
		}

		initSelectors() {
			this.productCard = '.product-card';
			this.contextMenuIcon = $('[data-js-context-menu]');
			this.showcases = $('.tabs-showcase');
			this.tabs = $('.tabs-showcase__list-item');
			this.tabContents = $('.tabs-showcase__tab-content');
			this.headerCartIcon = $('#header_cart_icon');
			this.buyAllBtn = $('.js-buy-all');
		}

		bindEvents() {
			if ($('body').hasClass('page-template-template-landing')) {
				let resizeTimer2;
				$(window).on('resize', () => {
					clearTimeout(resizeTimer2);
					resizeTimer2 = setTimeout(() => {
						this.qualizePortfolio2Heights();
					}, 250);
				});
			}


			this.contextMenuIcon.on('click', (e) => {
				e.stopPropagation();
				e.preventDefault();

				// Close all other open context menus first
				$('.context-menu--open').not($(e.currentTarget).siblings('.context-menu')).removeClass('context-menu--open');

				this.openContextMenu(e);
			});

			// Close menu when clicking anywhere else on the document
			$(document).on('click', (e) => {
				if (!$(e.target).closest('.context-menu').length && !$(e.target).hasClass('icon-dots')) {
					$('.context-menu--open').removeClass('context-menu--open');
				}
			});

			this.tabs.on('click', (e) => this.displayShowcaseBlockTabs(e));

			$(document).on('click', (e) => {
				const $filters = $('.filters.open');
				if (!$filters.length) return;

				const isToggleButton = $(e.target).closest('.js-filters-toggle').length > 0;
				if (isToggleButton) return;

				// Check if click is directly on .filters element (backdrop) or outside
				const isClickOnBackdrop = $(e.target).is('.filters');
				const isOutsideFilters = !$(e.target).closest('.filters').length;

				if (isClickOnBackdrop || isOutsideFilters) {
					$filters.removeClass('open');
					document.body.style.overflow = '';
				}
			});

			$(document).on('change', 'input[name="tax-country"]', (e) => {
				var country = $(e.currentTarget).val();
				$.post({
					url: w4d_frontend_ajax.ajax_url,
					data: {
						action: 'w4d_update_customer_country',
						nonce: w4d_frontend_ajax.nonce,
						country: country,
					},
					success: (response) => {
						if (response.success) {
							location.reload(); // refresh page to update prices based on new country
						} else {
							const errorMessage = response && response.data ? response.data.message : 'Došlo je do pogreške.';
							W4D_Toast.showToast('error', errorMessage);
						}
					},
					error: () => {
						W4D_Toast.showToast('error', 'Došlo je do pogreške. Pokušajte ponovno.');
					},
				});
			});

			this.buyAllBtn.on('click', (e) => this.handleBuyAll(e));
		}

		displayShowcaseBlockTabs(e) {
			const $clickedTab = $(e.currentTarget);
			const index = $clickedTab.data('tab-index');

			this.tabs.removeClass('tabs-showcase__list-item--active').attr('aria-selected', 'false');

			$clickedTab.addClass('tabs-showcase__list-item--active').attr('aria-selected', 'true');

			this.tabContents.removeClass('tabs-showcase__tab-content--active').attr('aria-hidden', 'true');

			this.tabContents
				.filter(`[data-tab-index="${index}"]`)
				.addClass('tabs-showcase__tab-content--active')
				.attr('aria-hidden', 'false');
		}

		openContextMenu(e) {
			e.preventDefault();
			$(e.currentTarget).siblings('.context-menu').toggleClass('context-menu--open');
		}

		parseUrlParams() {
			let urlParams = new URLSearchParams(window.location.search);
			let filters = {};
			let sort = null;
			let page = 1;
			const pathMatches = window.location.pathname.match(/\/page\/(\d+)\/?/);
			if (pathMatches) {
				page = parseInt(pathMatches[1]);
			}

			for (let [key, value] of urlParams.entries()) {
				if (
					key.startsWith('pa_') ||
					key === 'stock_status' ||
					key === 'product_tag' ||
					key === 'klasifikacija' ||
					key === 'discounts'
				) {
					filters[key] = value.split(',');
				} else if (key === 'price') {
					let [min, max] = value.split(',');
					filters[key] = {
						min: parseInt(min),
						max: parseInt(max),
					};
				} else if (key === 'sort') {
					sort = value;
				} else if (key === 'page') {
					page = parseInt(value);
				} else if (key === 'pg') {
					page = parseInt(value);
				}
			}

			// Sortiranje
			if (!sort) {
				const match = document.cookie.match(/(?:^| )w4d_sort=([^;]+)/);
				if (match) {
					sort = decodeURIComponent(match[1]);
				} else {
					sort = 'default';
				}
			}

			return { filters, sort, page };
		}


		setCookie(name, value, days, sameSite = 'Lax', secure = false) {
			let expires = '';
			if (days !== null) {
				const date = new Date();
				date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
				expires = `; expires=${date.toUTCString()}`;
			} else {
				const date = new Date();
				date.setFullYear(date.getFullYear() + 100);
				expires = `; expires=${date.toUTCString()}`;
			}
			const secureFlag = secure ? '; Secure' : '';
			document.cookie = `${name}=${value || ''}${expires}; path=/; SameSite=${sameSite}${secureFlag}`;
		}

		getCookie(name) {
			const nameEQ = `${name}=`;
			const cookies = document.cookie.split(';');

			for (let cookie of cookies) {
				cookie = cookie.trim();
				if (cookie.indexOf(nameEQ) === 0) {
					return cookie.substring(nameEQ.length);
				}
			}
			return null;
		}

		updateCartIcon(cartCount) {
			localStorage.setItem('w4d_cart_count', cartCount);
			this.headerCartIcon.attr('data-populated', cartCount);
			if (cartCount > 0) {
				this.headerCartIcon.addClass('w4d-header__btn--populated');
				this.headerCartIcon.removeClass('w4d-header__btn--adding');
				requestAnimationFrame(() => {
					this.headerCartIcon.addClass('w4d-header__btn--adding');
				});

				// Remove the animation class when animation ends
				this.headerCartIcon.one('animationend', () => {
					this.headerCartIcon.removeClass('w4d-header__btn--adding');
				});
			} else {
				this.headerCartIcon.removeClass('w4d-header__btn--populated');
			}
		}

		// Sync state without triggering add animation
		syncCartIcon(cartCount) {
			this.headerCartIcon.attr('data-populated', cartCount);
			if (cartCount > 0) {
				this.headerCartIcon.addClass('w4d-header__btn--populated');
				this.headerCartIcon.removeClass('w4d-header__btn--adding');
			} else {
				this.headerCartIcon.removeClass('w4d-header__btn--populated w4d-header__btn--adding');
			}
		}

		getQueryParameter(param) {
			const urlParams = new URLSearchParams(window.location.search);
			return urlParams.get(param);
		}

		updateCartFromStorage() {
			const cartCount = parseInt(localStorage.getItem('w4d_cart_count') || '0', 10);
			this.syncCartIcon(cartCount);
		}

		startButtonCountdownUntilEnabled(button, seconds = 10) {
			let remainingTime = seconds;
			const originalText = button.text();

			const updateText = () => {
				button.text(`Molimo pričekajte... (${remainingTime}s)`);
				remainingTime--;
			};

			updateText();

			const countdownInterval = setInterval(() => {
				if (remainingTime >= 0) {
					updateText();
				} else {
					clearInterval(countdownInterval);
					button.text(originalText);
					button.prop('disabled', false);
				}
			}, 1000);
		}

		checkHoneypot($form) {
			const honeypotValue = $form.find('#med').val() ?? '';

			if (honeypotValue !== '') {
				window.location.replace('about:blank');
				setTimeout(() => {
					history.pushState(null, null, 'about:blank');
					history.pushState(null, null, 'about:blank');
					history.go(-2);
				}, 0);
				return false; // Spam detected
			}

			return true; // Legitimate submission
		}

		handleBuyAll(e) {
			e.preventDefault();

			const $button = $(e.currentTarget);
			let add_to_cart_buttons = $button.parent().find($('.w4d_add_to_cart_button[data-product-id]'));
			if (!add_to_cart_buttons) {
				W4D_Toast.showToast('error', 'Lista proizvoda je prazna');
				return;
			}

			let products = {};
			add_to_cart_buttons.each(function () {
				var productId = $(this).data('product-id');

				if (!productId) {
					return;
				}

				var productQty = $(this).data('quantity');
				if (productQty) {
					products[productId] = productQty;
				} else {
					products[productId] = 1;
				}
			});

			if (Object.keys(products).length === 0) {
				W4D_Toast.showToast('error', 'Lista proizvoda je prazna');
				return;
			}

			const ajaxData = {
				action: 'w4d_add_collection_to_cart',
				nonce: w4d_frontend_ajax.nonce,
				items: products,
			};

			$.post({
				url: w4d_frontend_ajax.ajax_url,
				data: ajaxData,
				beforeSend: () => {
					this.buyAllBtn.prop('disabled', true);
				},
				success: (response) => {
					if (response.success) {
						W4D_Toast.showToast('success', 'Artikli su dodani u košaricu.');
						this.updateCartIcon(response.data.cart_count);
					} else {
						console.error(response);
						W4D_Toast.showToast('error', 'Došlo je do greške prilikom dodavanja artikla u košaricu.');
					}
				},
				error: (xhr, status, error) => {
					W4D_Toast.showToast('error', 'Greška: ' + response.data.message);
					console.error(response.data.message);
				},
				complete: () => {
					this.buyAllBtn.prop('disabled', false);
				},
			});
		}
	}

	$(document).ready(() => {
		window.W4D_FrontendHelper = new W4D_FrontendHelper();
	});
})(jQuery);
